import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './ExamSection.module.css';
import { ApiHitPost } from "../../../../Services/ApiHit";
import { useNavigate } from "react-router-dom";

const FadeInSection = ({ children, direction }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => setVisible(entry.isIntersecting));
    });
  
    const el = domRef.current;
  
    if (el instanceof Element) {
      observer.observe(el);
    }
  
    return () => {
      if (el instanceof Element) {
        observer.unobserve(el);
      }
    };
  }, []);

  return (
    <motion.div
      className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
      initial={{ opacity: 0, y: direction === 'up' ? 40 : -40 }}
      animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : direction === 'up' ? 40 : -40 }}
      transition={{ duration: 1, ease: 'easeOut' }}
      ref={domRef}
    >
      {children}
    </motion.div>
  );
};

const ExamSection = () => {

  const navigate = useNavigate();
    
  const handleClick = (path) => {
      navigate(path);
  };

  const [verticleList, setverticleList] = useState([]);
  
  useEffect(() => {
    const fetchVerticalList = async () => {
      try {
        const verticleListApiResponse = await ApiHitPost('/hierarchy/get_vertical_list');
        setverticleList(verticleListApiResponse.data.data);
      } catch (error) {
        console.error('Failed to load courses:', error);
      }
    };

    fetchVerticalList();
  }, []);
  
  return (
    <div className="bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <FadeInSection direction="up">
          <h2 className="text-3xl font-bold text-center mb-4">
            <span className="text-[#4267B2]">Exam</span> Categories
          </h2>
          <p className="text-lg text-gray-700 text-center mb-12">
            Discover our Courses and Resources Designed for Your Exam
          </p>
        </FadeInSection>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {verticleList.map((category, index) => (
            <FadeInSection key={index} direction={index % 2 === 0 ? 'up' : 'down'}>
              <motion.div 
                className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-md transition-shadow duration-300 ease-in-out"
                whileHover={{ scale: 1.05 }}
              >
                <div className="p-6 flex flex-col items-center">
                  <motion.div
                    className="w-16 h-16 rounded-lg flex items-center justify-center mb-4 transition-transform duration-300 ease-in-out"
                    style={{ backgroundColor: category.color }}
                    whileHover={{ scale: 1.15 }}
                  >
                    <img src={category.category_thumbnail_image} alt={category.category_name_english} className="w-16 h-16 object-contain" />
                  </motion.div>
                  <h3 className="text-xl font-semibold mb-2 text-gray-800">{category.category_name_english}</h3>
                  <p className="text-gray-500 text-sm mb-4 text-center">{category.category_short_description}</p>
                  <motion.button
                    className="bg-white text-[#4267B2] border border-[#4267B2] rounded-md px-4 py-2 text-sm font-medium hover:bg-primary hover:text-[#4267B2] transition-colors duration-300 ease-in-out"
                    whileHover={{ scale: 1.1 }}
                    onClick={() => handleClick(category.category_seo_url)}
                  >
                    View Courses
                  </motion.button>
                </div>
              </motion.div>
            </FadeInSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamSection;

